import TitleSubtitlePair from "../../_utils/TitleSubtitlePair";
import SingleSelectDropDownComponentWithIcon from "../../_utils/CommonDropdown/SingleSelectDropdownWithIcon";
import ICONS from "../../../assets/Icons";
import PrimaryRightIconFill from "../../_utils/CommonButtons/PrimaryRightIconFill";
import ChannelCreationGuidePopUp from "../ChannelCreationGuidePopUp";
import { linkIdentifier } from "../../../utils/linkIdentifier";
import TEXT from "../../../utils/globalText";

const SelectTargetChannel = ({
  logoUrl,
  copyLogoURL,
  setCopyLogoURL,
  channelPayLoad,
  setChannelPayLoad,
  channelOptions,
  channelDropdownOpen,
  setChannelDropdownOpen,
  channelCreationGuide,
  setChannelCreationGuide,
}) => {
  const formattedOptions = channelOptions?.map((x) => ({
    label: x.name,
    value: x.value,
    icon: x.icon,
  }));

  const selectedOption =
    formattedOptions?.find(
      (opt) => opt.value === channelPayLoad?.channelTarget,
    ) || "";

  const handleDropdownChange = (val) => {
    setChannelPayLoad((prev) => ({
      ...prev,
      channelTarget: val?.value,
    }));
  };

  return (
    <>
      {channelCreationGuide && (
        <div className="fixed top-top-base left-left-base w-screen h-screen bg-PopUp-BackDrop bg-opacity-dark-opacity z-z-index-modal">
          <ChannelCreationGuidePopUp
            logoUrl={logoUrl}
            copyLogoURL={copyLogoURL}
            setCopyLogoURL={setCopyLogoURL}
            channelPayLoad={channelPayLoad}
            channelCreationGuide={channelCreationGuide}
            setChannelCreationGuide={setChannelCreationGuide}
          />
        </div>
      )}
      <div className="flex flex-col global-card-create gap-gap-md h-full">
        <TitleSubtitlePair
          title={`${TEXT?.TARGET} ${TEXT?.CHANNEL.toLowerCase()}`}
          subtitle={TEXT?.SELECT_NOTIFICATION_SOURCE}
          isBold={true}
          variant="md"
          titleColor="text-primary"
        />

        <SingleSelectDropDownComponentWithIcon
          selected={selectedOption}
          options={formattedOptions}
          setSelected={handleDropdownChange}
          isOpen={channelDropdownOpen}
          placeholder={`${TEXT?.SELECT} ${TEXT?.CHANNEL.toLowerCase()}`}
          showSearch={false}
          showIconBackground={false}
          type="big"
        />

        {channelPayLoad?.channelTarget &&
          channelPayLoad?.channelTarget !== "generic" && (
            <div className="border border-primary-bg"></div>
          )}
        {channelPayLoad?.channelTarget &&
          channelPayLoad?.channelTarget !== "generic" && (
            <div className="flex flex-col gap-gap-md">
              <TitleSubtitlePair
                title={linkIdentifier(
                  channelPayLoad.channelTarget === "teams"
                    ? "https://support.microsoft.com/en-US/Workflows/send-messages-in-teams-using-incoming-webhooks"
                    : channelPayLoad.channelTarget === "slack"
                      ? "https://docs.slack.dev/messaging/sending-messages-using-incoming-webhooks"
                      : " https://support.google.com/chat/answer/12176488?hl=en&co=GENIE.Platform%3DDesktop",
                )}
                subtitle={
                  channelPayLoad.channelTarget === "teams"
                    ? TEXT?.MICROSOFT_TEAMS_WEBHOOK_GUIDE
                    : channelPayLoad.channelTarget === "slack"
                      ? TEXT?.SLACK_WEBHOOK_GUIDE
                      : TEXT?.GOOGLE_CHAT_CHANNEL_GUIDE
                }
                variant="sm"
                titleColor="text-primary"
              />
              {channelPayLoad.channelTarget === "gchat" && (
                <TitleSubtitlePair
                  title={linkIdentifier(
                    "https://developers.google.com/workspace/chat/quickstart/webhooks",
                  )}
                  subtitle={TEXT?.GOOGLE_CHAT_WEBHOOK_GUIDE}
                  variant="sm"
                  titleColor="text-primary"
                />
              )}

              <p className="flex items-center justify-center text-text-secondary font-normal text-font-xs">
                {TEXT?.OR}
              </p>
            </div>
          )}

        {channelPayLoad?.channelTarget &&
          channelPayLoad?.channelTarget !== "generic" && (
            <div className="flex flex-col gap-gap-sm">
              <PrimaryRightIconFill
                btnText={TEXT?.GUIDE_FOR_CHANNEL_CREATION}
                enabledBgColor="var(--primary-nav-act)"
                isDisabled={false}
                handleFunction={() => setChannelCreationGuide(true)}
                iconToBeAlign="right"
                enabledTextColor={"var(--text-primary)"}
                icon={ICONS?.ARROW_RIGHT_WHITE}
                fullWidthRequired={true}
                hoverOption="white"
                imgColor={"var(--text-primary)"}
              />

              <p className="text-text-primary text-font-xs font-normal flex-shrink-0">
                {TEXT?.CHANNEL_GUIDE_REFERENCE_NOTE}
              </p>
            </div>
          )}
      </div>
    </>
  );
};

export default SelectTargetChannel;
